<template>
    <div @click="selected($event)" class="dropdown-text-result">
        {{result.term}}
    </div>
</template>

<script>
    export default {
        name: "DropdownTextResult",
        props: ['result', 'select', 'current'],
        methods: {
            selected(e) {
                this.$emit('input', this.result);
            },
            watch: {
                select(newVal, oldVal) {
                    if (newVal) {
                        this.selected();
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
